import React, { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import {
  ADD_RIGHT,
  DELETE_RIGHT,
  UPDATE_RIGHT,
  VIEW_RIGHT,
  VIEWOFOTHER_RIGHT,
} from "../../../../../utils/constants";
import { useBackdropContext } from "../../../../../contexts/backdrop/BackdropProvider";
import { asyncSearchList } from "../../../../../utils/httpRequests";
import ModuleComponent from "./ModuleComponent";
import { useSelector } from "react-redux";

type ModuleType = {
  _id: string;
  title: string;
  code: string;
  rights: string[];
};

const allRight: string[] = [
  VIEW_RIGHT,
  VIEWOFOTHER_RIGHT,
  ADD_RIGHT,
  UPDATE_RIGHT,
  DELETE_RIGHT,
];

const modules: ModuleType[] = [
  {
    _id: "cr_thuoc",
    code: "cr_thuoc",
    title: "Danh mục thuốc",
    rights: allRight,
  },
  {
    _id: "danhmucidthuoc",
    code: "danhmucidthuoc",
    title: "Danh mục ID thuốc",
    rights: allRight,
  },
  {
    _id: "cr_vtyt",
    code: "cr_vtyt",
    title: "Danh mục VTYT",
    rights: allRight,
  },
  {
    _id: "cr_hc",
    code: "cr_hc",
    title: "Danh mục hóa chất",
    rights: allRight,
  },
  {
    _id: "participant",
    code: "participant",
    title: "Người dùng",
    rights: allRight,
  },
  {
    _id: "fos_rpkeysearch2",
    code: "fos_rpkeysearch2",
    title: "Báo cáo kết quả tìm kiếm",
    rights: [VIEW_RIGHT, VIEWOFOTHER_RIGHT],
  },
];

interface IPhanquyenSection {
  data: any;
}

function PhanquyenSection({ data }: IPhanquyenSection) {
  const { token } = useSelector((state: any) => state.auth);
  const { setOpenBackdrop } = useBackdropContext();
  const [rightObj, setRightObj] = useState<any>({});

  // get rights
  const getRights = async () => {
    try {
      setOpenBackdrop?.(true);
      const resp = await asyncSearchList({
        apiCode: "right",
        token,
        condition: { page: 1, limit: 90000, q: { email: data._id } },
      });
      const rights = resp?.data || [];
      const rightToSave: { [key: string]: any } = {};
      rights.forEach((r: any) => (rightToSave[r.module] = r));
      setRightObj(rightToSave);
    } catch (error) {
    } finally {
      setOpenBackdrop?.(false);
    }
  };

  useEffect(() => {
    getRights();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?._id]);

  return (
    <Stack gap={1}>
      {modules.map((module) => {
        return (
          <ModuleComponent
            key={module._id}
            module={module}
            rightObj={rightObj}
            userGroup={data}
            getRights={getRights}
          />
        );
      })}
    </Stack>
  );
}

export default PhanquyenSection;
